
import * as ds from '~/scriptData/ds/dsCommon.js'
import { commonfunc } from '@/mixin/common.js'
export default {
  mixins: [commonfunc],
  props: {
    showTopBanner: {
      type: Boolean,
      default: false
    },
    accounts: {
      type: Array,
      default: () => { return [] }
    },
    bannerId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      topbaner: false,
      bannerItem: {},
      exhCmptmtId: '',
      bannerArr: []
    }
  },
  fetch () {
    this.getBannerImg()
  },
  watch: {
    showTopBanner: function (visible) {
      if (visible) {
        this.getBannerImg()
      }
    },

  },
  methods: {
    async getBannerImg () {
      const banners = await ds.getMtrlsList(this.accounts, this.$api)
      if (banners.length > 0) {
        this.bannerItem = banners?.[0]?.[0]
        this.topbaner = true
      }
    },
    errorLogo (e) {
      e.target.src = '/images/tempLy/@temp_top_banner.png'
    },
    moveToUrl (url) {
      const linkUrl = this.isNotEmpty(url) ? this.unescape(url) : '/ds'
      this.$router.push(linkUrl)
    }
  }
}
